// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 538) return "/vendors/child-vendors.min.css";
	// return url for filenames based on template
	return undefined;
};